<div class="modal flex items-center justify-center overflow-hidden p-4 fadeIn py-8 z-50" (click)="this.close($event)"
  style="z-index: 20;">
  <div style="background: #F9F9F9;"
    class="rounded p-4 w-full overflow-y-scroll md:overflow-y-hidden max-w-[900px] h-full flex flex-col md:flex-row items-stretch gap-4 px-2 justify-start md:justify-center relative">
    <mk-icon-button (click)="this.close(null)" class="absolute right-6 top-6 md:!hidden aspect-square w-[50px] scale-80" [fullscale]="true" direction="rtl" icon="cancel" useSvg="false" [label]="''" />


    <div class="flex-1 h-fit md:h-full flex flex-col rounded border border-gris-3 bg-white max-w-128 p-4">
      <div class="flex items-center gap-2 border-bottom-1 border-gris-3 pb-3">
        <div class="bg-vert-3 p-2 rounded">
          <allergens-indicator class="" [isAllergenPresent]="false" forceColor="#8abd27"/>
        </div>

        <p class="font-bold fg-noir-1">
          {{ child ? 'Les' : 'Mes' }}
          allergènes
          {{ child ? ('de ' + child!.firstname) : '' }}
        </p>
      </div>

      <div class="flex-1 w-full overflow-y-auto pt-4 border-bottom-1 relative" style="border-color: #F5F6F7;"
        [class.cursor-not-allowed]="this.areAllergensExcludedFromPlan"
        [class.pointer-events-none]="this.areAllergensExcludedFromPlan"
        >
        <table class="w-full">
          <thead class="text-xs fg-gris-1">
            <tr>
              <th class="font-medium text-center">Allergène</th>
              <th class="font-medium text-center">Présent</th>
            </tr>
          </thead>
          <tbody>
            @for (allergen of allergens|keyvalue; track allergen) {
              <tr>
                <td class="py-2 text-xs font-medium fg-noir-2 px-4">{{ this.extractAllergenName(allergen.value) }}</td>
                <td class="pr-2 h-12 py-1">
                  <toogle-switch [data]="allergen.key" [isOn]="this.isAllergenMarked(parseInt(allergen.key))" class="block h-full"
                    #allergenSwitches/>
                  </td>
                </tr>
              }
            </tbody>
          </table>

          @if (this.areAllergensExcludedFromPlan) {
            <div
              class="absolute left-0 top-0 right-0 bottom-0 bg-black/60 backdrop-blur-sm flex items-center justify-center flex-col">
              <p class="text-white text-xl font-semibold text-center px-2">Le filtre des allergènes est désactivé par le restaurant.</p>
            </div>
          }
        </div>

        <div class="w-full py-2 text-xs fg-noir-2">
          <p class="font-bold mb-1">Légende</p>

          <div class="flex items-center gap-2 border-top-1 border-gris-3 mt-1">
            <allergens-indicator [isAllergenPresent]="false"/>
            <p>Le plat contient des allergènes.</p>
          </div>
          <div class="flex items-center gap-2 border-top-1 border-gris-3 mt-1">
            <allergens-indicator [isAllergenPresent]="true"/>
            <p>Un allergène auquel vous êtes allergique est présent.</p>
          </div>
        </div>
      </div>
      <div class="flex-1 h-fit md:h-full flex flex-col rounded border border-gris-3 bg-white max-w-128 p-4">
        <div class="flex items-center gap-2 border-bottom-1 border-gris-3 pb-3">
          <div class="bg-vert-3 p-2 rounded">
            <allergens-indicator class="" [isAllergenPresent]="false" forceColor="#8abd27"/>
          </div>

          <p class="font-bold fg-noir-1">Préferences</p>
        </div>
        <div class="overflow-y-auto fg-noir-2 relative p-2">
          <p class="font-bold mb-1 text-sm my-2">Services à afficher</p>
          <table class="w-full">
            <tbody>
              @for (service of this.allServices; track service) {
                <tr>
                  <td class="font-semibold text-xs">
                    {{ (service?.name || '').replaceAll("_", " ") }}
                  </td>
                  <td class="w-32 h-12 py-1">
                    <toogle-switch [isOn]="!this.isServiceShowed($safeNavigationMigration(service?.svc_id))" class="block h-full" #serviceSwitches
                      [data]="$safeNavigationMigration(service?.svc_id)"/>
                    </td>
                  </tr>
                }
              </tbody>
            </table>

            @if (child !== null && !this.lockServicesFiltersBecauseOfUserFoodProfile) {
              <div
                class="absolute left-0 top-0 right-0 bottom-0 bg-black/60 rounded backdrop-blur-sm flex items-center justify-center text-white font-bold text-center text-sm px-2">
                Le filtre des services est déterminé par les profils alimentaires de {{ this.child.firstname }}
                ({{ this.formatFoodProfiles(this.child.foodProfiles) }}).
              </div>
            }

            @if (child === null && this.allServices.length <= 1 && !this.lockServicesFiltersBecauseOfUserFoodProfile) {
              <div
                class="absolute left-0 top-0 right-0 bottom-0 bg-black/60 rounded backdrop-blur-sm flex items-center justify-center text-white font-bold text-center text-sm px-2">
                Il n'y a qu'un seul service disponible. <br>Aucun filtrage n'est possible.
              </div>
            }

            @if (this.lockServicesFiltersBecauseOfUserFoodProfile) {
              <div
                class="absolute left-0 top-0 right-0 bottom-0 bg-black/60 rounded backdrop-blur-sm flex items-center justify-center text-white font-bold text-center text-sm px-2">
                Le filtre des services est déterminé par vos profils alimentaires ({{ this.formatFoodProfiles(this.foodProfiles) }}).
              </div>
            }
          </div>
          <div class="overflow-y-auto fg-noir-2">
            <p class="font-bold mb-1 text-sm my-2">Accessibilité</p>
            <table class="w-full">
              <tbody>
                <tr>
                  <td class="font-semibold text-xs">Nom des plats en majuscule</td>
                  <td class="w-32 h-12 py-1">
                    <toogle-switch [isOn]="this.isUppercaseNamesActive()" #uppercaseCourses/>
                  </td>
                </tr>
                <tr>
                  <td class="font-semibold text-xs">Nom des plats en gras</td>
                  <td class="w-32 h-12 py-1">
                    <toogle-switch [isOn]="this.isBoldCoursesActive()" #boldCourses/>
                  </td>
                </tr>
                <tr>
                  <td class="font-semibold text-xs">Mode dyslexie</td>
                  <td class="w-32 h-12 py-1">
                    <toogle-switch [isOn]="this.isDyslexic()" #dyslexic/>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>

        </div>

        @if (this.loading) {
          <div
            class="absolute left-0 top-0 right-0 bottom-0 bg-black/50 text-white flex flex-col items-center justify-center text-center">
            <p class="text-xl font-semibold">
              Enregistrement des préferences en cours...
            </p>
            <span class="material-icons text-4xl animate-spin">
              refresh
            </span>
          </div>
        }
      </div>
    </div>
